import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDecimalNumberOnly]',
})
export class DecimalNumberOnlyDirective implements OnInit {
  @Input() decimalPlaces: number = 5; // Default is 5
  @Input() digitBeforeDecimal: number = 20; // Default is 5
  @Input() isPercentage: boolean = false;
  @Input() isNegativeAllowed: boolean = false;
  @Input() formatReadOnlyData: boolean = false;
  constructor(
    public element: ElementRef,
    private control: NgControl,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    if (this.decimalPlaces < 0) {
      this.decimalPlaces = 5;
    }
    if (this.formatReadOnlyData) {
      setTimeout(() => {
        this.formatInputValue();
      }, 500);
    }
  }
  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.element.nativeElement as HTMLInputElement;
    let value = input.value.trimStart();

    // Allow digits, dot, and minus (if negative is allowed)
    value = value.replace(
      this.isNegativeAllowed ? /[^0-9.-]/g : /[^0-9.]/g,
      ''
    );

    // Allow only one minus and it must be at the start
    if (this.isNegativeAllowed) {
      const minusCount = (value.match(/-/g) || []).length;
      if (minusCount > 1 || (minusCount === 1 && !value.startsWith('-'))) {
        value = value.replace(/-/g, '');
      }
    }

    // Allow only one dot
    const dotCount = (value.match(/\./g) || []).length;
    if (dotCount > 1) {
      const first = value.indexOf('.');
      value =
        value.substring(0, first + 1) +
        value.slice(first + 1).replace(/\./g, '');
    }

    let isNegative = false;
    if (value.startsWith('-')) {
      isNegative = true;
      value = value.substring(1); // remove minus for processing
    }

    let integerPart = '';
    let decimalPart = '';
    let hasDot = value.includes('.');

    if (hasDot) {
      [integerPart, decimalPart] = value.split('.');
    } else {
      integerPart = value;
    }

    // Trim integer and decimal part as per limits
    if (integerPart.length > this.digitBeforeDecimal) {
      integerPart = integerPart.substring(0, this.digitBeforeDecimal);
    }

    if (decimalPart && decimalPart.length > this.decimalPlaces) {
      decimalPart = decimalPart.substring(0, this.decimalPlaces);
    }

    // Handle percentage logic
    if (this.isPercentage) {
      const parsed = parseFloat(`${integerPart}.${decimalPart || ''}`);
      if (parsed >= 100) {
        integerPart = '100';
        decimalPart = '';
        isNegative = false; // negative % not allowed
        hasDot = false;
      }
    }

    let finalValue = integerPart;
    if (hasDot) {
      finalValue += '.' + (decimalPart || '');
    }

    if (isNegative) {
      finalValue = '-' + finalValue;
    }

    // Set cleaned and formatted value
    this.control.control?.setValue(finalValue);
  }

  private formatInputValue(): void {
    const input = this.element.nativeElement as HTMLInputElement;
    let value = input.value;

    if (value) {
      let parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        parsed = Math.floor(parsed * 100) / 100;
        const formatted = parsed.toFixed(this.decimalPlaces);
        this.renderer.setProperty(input, 'value', formatted);
      } else {
        this.renderer.setProperty(input, 'value', '');
      }
    }
  }
}
